import { resolveBookIdentity } from '../lib/bookLogoRegistry.js'
import { MARKET_QUALITY_WEIGHTS } from '../lib/liveOddsFairValueV1.js'

export default function LiveOddsVNextBookUniverse({ books, selectedBooks, setSelectedBooks, weighting }) {
  const selected = selectedBooks == null ? new Set(books) : new Set(selectedBooks)
  const toggle = (book) => {
    const next = new Set(selected)
    if (next.has(book)) next.delete(book)
    else next.add(book)
    setSelectedBooks([...next])
  }
  return <details className="lovxu-books">
    <summary><strong>Sportsbook universe</strong><span>{selected.size}/{books.length} selected</span><small>Controls Avg, Fair, Vig, Breadth, Best, and every visible book column.</small></summary>
    <div className="lovxu-actions"><button type="button" onClick={() => setSelectedBooks(null)}>Select all</button><button type="button" onClick={() => setSelectedBooks([])}>Clear all</button></div>
    <div className="lovxu-grid">{books.map((book) => {
      const identity = resolveBookIdentity(book)
      const weight = weighting === 'market_quality' ? Number(MARKET_QUALITY_WEIGHTS[book] ?? 1) : 1
      return <label key={book} className={selected.has(book) ? 'active' : ''}>
        <input type="checkbox" checked={selected.has(book)} onChange={() => toggle(book)} />
        {identity.logoUrl ? <img src={identity.logoUrl} alt="" loading="lazy" /> : <b>{identity.displayName.slice(0, 3)}</b>}
        <span>{identity.displayName}</span><small>{weight.toFixed(2)}x</small>
      </label>
    })}</div>
  </details>
}
